export default {
  SUBMIT: {
    ERROR: {
      title: 'There was an issue submitting the feedback',
      severity: 'error' as 'error'
    },
    SUCCESS: {
      title: 'Feedback has been submitted',
      severity: 'success' as 'success'
    }
  }
};
